import { render, staticRenderFns } from "./ChangeLogDelta.vue?vue&type=template&id=4ade0189"
import script from "./ChangeLogDelta.vue?vue&type=script&lang=js"
export * from "./ChangeLogDelta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports